import { useGeolocation } from "./hooks/useGeolocation";

export const CliID = "406540c8-6707-11ec-8b89-005056817138";
//const Url = "http://127.0.0.1/edsa-apps/bodasavos/php_eventos/";
const Url = "//ferreirafr.sslblindado.com/api/";
export default Url;


export const useCookie = () => {
    const get = (find) => {
        let arr = document.cookie===""?[]:document.cookie.split(";");
        let value = "";
        arr.forEach(element => {
            if (element.trim().split("=")[0].trim() === find)
                value = element.trim().split("=")[1].trim();
        });            
        return value;
    }

    const set = (name, value) => {
        document.cookie = name + "=" + value;
    }

    const removeAll = () => {
        set("AppAuthOB","nononono");
        set("UserOB","Login");
        set("Perfil","NOPE");
    }

    return {
        get,
        set,
        removeAll,
    }
}